import Controller from '@ember/controller';

export default class AuthenticatedTeamsShowIssuesController extends Controller {}
